<app-icon class="sidebar-icon text-grey-50" [name]="icon"></app-icon>
<ng-content></ng-content>